'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _stage = require('../stage/stage');

var _stage2 = _interopRequireDefault(_stage);

var _scrollingHelper = require('../helpers/scrolling-helper');

var _scrollingHelper2 = _interopRequireDefault(_scrollingHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class Hall
 * A component for rendering a hall
 * in a virtual expo.
 */
var Hall = function (_Component) {
  _inherits(Hall, _Component);

  function Hall() {
    _classCallCheck(this, Hall);

    return _possibleConstructorReturn(this, (Hall.__proto__ || Object.getPrototypeOf(Hall)).apply(this, arguments));
  }

  _createClass(Hall, [{
    key: 'componentWillMount',

    /** @method componentWillMount
      * Display the hall name in the navigation bar
      */
    value: function componentWillMount() {
      if (window.vexpo && window.vexpo.navigation && window.vexpo.navigation.setLocationName) {
        window.vexpo.navigation.setLocationName(this.props.name);
      }
    }
    /** @method componentWillReceiveProps()
      * Display the hall name in the navigation bar
      */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (window.vexpo && window.vexpo.navigation && window.vexpo.navigation.setLocationName) {
        window.vexpo.navigation.setLocationName(newProps.name);
      }
    }
    /** @function
     * Renders the hall component.
     */

  }, {
    key: 'render',
    value: function render() {
      var help = this.props.editorPreview ? "" : _react2.default.createElement(_scrollingHelper2.default, null);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_stage2.default, _extends({}, this.props.stage, { identifier: this.props.hallID, editorPreview: this.props.editorPreview })),
        help
      );
    }
  }]);

  return Hall;
}(_react.Component);

exports.default = Hall;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/hall/hall.js
// module id = 263
// module chunks = 0